import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { GoogleMapContext } from '../contexts';
import loader from '../instance/googleMapsLoader.js';

export const GoogleMapProvider = (props) => {
  const { children } = props;
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState(null);
  const [address, setAddress] = useState(null);
  const [fullAddress, setFullAddress] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadGoogleMaps = async () => {
      try {
        setError(null);
        // 언어 · 지역 · API 버전 로드 포함
        await loader.importLibrary('places');
        await loader.importLibrary('maps');

        if (isMounted) {
          setIsLoaded(true);
        }
      } catch (err) {
        console.error('Google Maps load error:', err);
        if (isMounted) {
          setError(err);
          setIsLoaded(false);
        }
      }
    };

    loadGoogleMaps();

    return () => {
      isMounted = false;
    };
  }, []);

  const setAddressHandler = useCallback((newAddress) => {
    setAddress(newAddress);
  }, []);

  const setFullAddressHandler = useCallback((newFullAddress) => {
    setFullAddress(newFullAddress);
  }, []);

  const contextValue = useMemo(
    () => ({
      isLoaded,
      error,
      address,
      setAddress: setAddressHandler,
      fullAddress,
      setFullAddress: setFullAddressHandler,
    }),
    [isLoaded, error, address, setAddressHandler, fullAddress, setFullAddressHandler],
  );

  return <GoogleMapContext.Provider value={contextValue}>{children}</GoogleMapContext.Provider>;
};
